import {
  userStatus,
  envConfig,
  EncryptMe
} from '../_helpers';

export const mediaServices = {
  listMediaByDomain
}

async function listMediaByDomain(uuid) {
  const user = userStatus();

  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.bearer_token}`,
      'req-language': 'pt_BR'
    }
  }

  const response = await fetch(`${envConfig.MOMENTUM_API_URL}/gallery/list/${uuid}/domain`, options);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}